<script src="../../../node_modules/suncalc/suncalc.js"></script>
<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>

        <v-layout row wrap  v-if="!loading&&ecConfig">
            <v-flex xs12 :class="[showClock ? 'lg10' : 'lg12']">
                <vue-echart :white-mode="whiteMode" :config="ecConfig" :height="height" :update-options="{}"></vue-echart>
            </v-flex>
            <v-flex lg2 v-if="showClock">
                <v-time-picker v-model="clock" format="24hr" @change="clockChange" full-width
                               ></v-time-picker>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import VueEchart from "@/components/VueEchart";
import LoadingProgressBar from "../LoadingProgressBar";
import * as SunCalc from 'suncalc'
import * as echarts from 'echarts';
import 'echarts-gl';
import moment from "moment";

export default {
    props: {
        whiteMode: {type: Boolean, default: false},
        showClock: {type: Boolean, default: false},
        mainIntensity: {type: Number, default: 6},
        ambientIntensity: {type: Number, default: 0},
        height: {type: Number, default: 300},
        dateRange: {type: Object, default: null},
        featuresJson: {type: String, default: null},
        lat: {type: Number, default: null},
        lon: {type: Number, default: null},
    },
    components: {VueEchart, LoadingProgressBar},
    computed: {
        ecConfig() {
            if (!this.featuresJson || this.featuresJson === ""||this.regions.length===0) {
                return null
            }
            return {
                series: [
                    {
                        type: 'map3D',
                        map: 'buildings',
                        shading: 'realistic',
                        opacity: 1,
                        postEffect: {
                            enable: true,
                            bloom: {
                                enable: false
                            },
                            SSAO: {
                                enable: true,
                                quality: 'high',
                                radius: 10,
                                intensity: 1.2
                            },
                            FXAA:{
                                enable:true
                            }
                        },
                        groundPlane: {
                            show: true,
                            color: '#333',
                            opacity: 1,
                        },
                        light: {
                            main: {
                                intensity: this.mainIntensity,
                                shadow: true,
                                shadowQuality: 'high',
                                alpha: this.alpha,
                                beta: this.beta,
                            },
                            ambient: {
                                intensity: this.ambientIntensity
                            },
                        },
                        viewControl: {
                            minBeta: -360,
                            maxBeta: 360,
                        },
                        silent:true,
                        data: this.regions
                    }
                ]
            }
        }
    },
    name: 'SolarWidget',
    data: function () {
        return {
            interval: null,
            configIndex: 0,
            config: null,
            loading: false,
            timeout: null,
            clock:moment().format("HH:mm"),
            alpha:30,
            beta:30,
            regions:[],
        }
    },
    beforeDestroy: function () {
        clearInterval(this.interval)
    },
    watch: {
        featuresJson() {
            this.refresh()
        },
    },
    mounted: function () {
        this.refresh()
    },
    methods: {
        clockChange(){
            let time= moment(this.clock, 'HH:mm');
            let coords=SunCalc.getPosition(moment().hour(time.hour()).minute(time.minute()).toDate(), this.lat, this.lon)
            this.alpha=coords.altitude*(180/Math.PI)
            this.beta=coords.azimuth*(180/Math.PI)-180
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.refreshBIM, 500);
        },

        async refreshBIM() {
            clearInterval(this.interval)
            this.loading = true
            this.regions=[]
            if (this.featuresJson && this.featuresJson !== "") {
                let decodedFeatures = JSON.parse(this.featuresJson)
                for (let feature of decodedFeatures.features) {
                    if(feature.properties.NAME&&!feature.properties.name){
                        feature.properties.name = feature.properties.NAME
                    }
                }
                echarts.registerMap('buildings', decodedFeatures);
                this.regions= decodedFeatures.features.map(function (feature) {
                    return {
                        name: feature.properties.name,
                        value: Math.max(feature.properties.BD_STOREY*4.5, 0.1),
                        height: Math.max(feature.properties.BD_STOREY, 0.1)
                    };
                });
            }
            if(this.lat&&this.lon){
                let coords=SunCalc.getPosition(new Date(), this.lat, this.lon)
                this.alpha=coords.altitude*(180/Math.PI)
                this.beta=coords.azimuth*(180/Math.PI)-180
            }
            setTimeout(() => { this.loading = false}, 300);
        }
    }
}

</script>

<style scoped>

</style>
